<p-dialog
        [visible]="visible()"
        [modal]="true"
        [closable]="closable()"
        [style]="{ width: width(), height: height() }"
        (onHide)="visibleChange.emit(false)">

    <ng-template #header>
        <div class="flex flex-col">
            <div class="header-title-dialog">{{ headerTitle() }}</div>
        </div>
    </ng-template>

    <ng-content>
        <div class="break-words">
            {{ message() }}
        </div>
    </ng-content>

    <ng-template #footer>
        <p-button [label]="cancelLabel()" styleClass="btn-transparent" (click)="onClickCancel()"></p-button>
        <p-button [label]="confirmLabel()" styleClass="btn-red" (click)="onClickConfirm()"></p-button>
    </ng-template>
</p-dialog>